<template>

    <div>
        <v-row class="my-8">
            <v-col style="padding: 0;" cols="12">
                <v-card class="mx-auto"  flat dark tile style="background:transparent;text-align: center;height: 40px;width:100%;">

                    <v-chip
                            class="ma-2"
                            color="green"
                            text-color="white"
                            label
                    >
                        <v-avatar
                                left
                                class="green darken-4 pl-0"
                        >
                            {{num_rank0}}
                        </v-avatar>
                        Vanlig
                    </v-chip>
                    <v-chip
                            class="ma-2"
                            color="blue"
                            text-color="white"
                            label
                    >
                        <v-avatar
                                left
                                class="blue darken-4 pl-0"
                        >
                            {{num_rank1}}
                        </v-avatar>
                        Rare
                    </v-chip>
                    <v-chip
                            class="ma-2"
                            color="purple"
                            text-color="white"
                            label
                    >
                        <v-avatar
                                left
                                style=""
                                class="purple darken-4 pl-0"
                        >
                            {{num_rank2}}
                        </v-avatar>
                        Epic
                    </v-chip>
                    <v-chip
                            class="ma-2"
                            color="orange"
                            text-color="white"
                            label
                    >
                        <v-avatar
                                left
                                class="orange darken-4 pl-0"
                        >
                            {{num_rank3}}
                        </v-avatar>
                        Legendary
                    </v-chip>


                </v-card>
            </v-col>
        </v-row>


        <v-sheet
                dark
                show-arrows
                style="width:100%;background: transparent;margin-bottom:10px;min-height: 190px;"
        >
            <v-slide-group dark  :show-arrows="true" >
                <v-spacer></v-spacer>
                <v-slide-item
                        dark
                        :key=index
                        v-for="(award,index) in awards.concat(awards_dynamic)"



                >
                    <v-card  class="mx-2 grow_me_badge" width="250" raised dark style="text-align: center;" :style="{'background':colors[index % 2]}" >
                        <v-card-subtitle class="font-weight-bold">
                            {{award.title}}
                        </v-card-subtitle>


                        <v-img v-if="!award.bg" class="mx-auto" :src="award.image" contain height="100" width="100">

                        </v-img>

                        <div style="position: relative;height:100px;" v-if="award.bg">
                            <div style="width:70px;height:70px;left:90px;top:5px;"  class="image-cropper">
                                <img  style="position: relative;z-index: 0;display: inline; margin: 0 auto; height: 100%; width: auto;margin-left: -25% !important;" class="mx-auto" :src="award.bg"/>


                            </div>
                            <v-img  style="position: relative;z-index: 1;top:-70px;"  class="mx-auto" :src="award.image" contain height="100" width="100">

                            </v-img>
                        </div>




                        <v-card-text style="font-size:0.8em;padding-bottom:0;">
                            {{award.desc}}
                        </v-card-text>
                    </v-card>
                </v-slide-item>
                <v-spacer></v-spacer>

            </v-slide-group>
        </v-sheet>
    </div>
</template>

<script>
    export default {
        name: "HicardsStats",
        props:["name","image"],
        data(){
            return{
                num_rank0:0,
                num_rank1:0,
                num_rank2:0,
                num_rank3:0,
                award_templates:[
                    {title:"Tycoon",key:"COUNT_TRADES",value:100,desc:"Utför 100 byten",image:"/api/images/cards/medal3_trade.png" },
                    {title:"Closer",key:"COUNT_TRADES",value:50,desc:"Utför 50 byten",image:"/api/images/cards/medal2_trade.png" },
                    {title:"Hustler",key:"COUNT_TRADES",value:15,desc:"Utför 15 byten",image:"/api/images/cards/medal1_trade.png"},
                    {title:"Trader",key:"COUNT_TRADES",value:5,desc:"Utför 5 byten",image:"/api/images/cards/medal0_trade.png" },

                    {title:"Casanova",key:"COUNT_DIFFERENT_STREAMER",value:30,desc:"Samla kort från 30 olika streamers",image:"/api/images/cards/medal3.png" },
                    {title:"Player",key:"COUNT_DIFFERENT_STREAMER",value:15,desc:"Samla kort från 15 olika streamers",image:"/api/images/cards/medal2.png" },
                    {title:"Heartbreaker",key:"COUNT_DIFFERENT_STREAMER",value:5,desc:"Samla kort från 5 olika streamers",image:"/api/images/cards/medal1.png" },
                    {title:"Charmer",key:"COUNT_DIFFERENT_STREAMER",value:2,desc:"Samla kort från 2 olika streamers",image:"/api/images/cards/medal0.png" },

                ],
                award_templates_dynamic:[
                    {bg:true,title:"Philantropist",key:"COUNT_SAME_STREAMER",value:30,desc:"Samla 100 kort från X",image:"/api/images/cards/medal3_hollow.png" },
                    {bg:true,title:"Patron",key:"COUNT_SAME_STREAMER",value:15,desc:"Samla 50 kort från X",image:"/api/images/cards/medal2_hollow.png" },
                    {bg:true,title:"Supporter",key:"COUNT_SAME_STREAMER",value:5,desc:"Samla 15 kort från X",image:"/api/images/cards/medal1_hollow.png" },
                    {bg:true,title:"Follower",key:"COUNT_SAME_STREAMER",value:2,desc:"Samla 5 kort från X",image:"/api/images/cards/medal0_hollow.png" },

                ],

                stats:null,
                by_streamer_stats:null,
                colors:["rgba(45,45,45,0.8)","rgba(36,36,36,0.8)"]



            }
        },
        mounted:function(){
            this.get_user_data();
            this.get_card_stats();
        },
        computed:{
            awards:function(){
                let arr=[];
                if(this.stats!==null){
                    for(let i =0;i<this.award_templates.length;i++){
                        if(this.award_templates[i].value <= this.stats[this.award_templates[i].key] ){
                            arr.push(this.award_templates[i])
                        }
                    }
                }


                return arr;


            },
            awards_dynamic:function(){
                let arr=[];
                if(this.by_streamer_stats!==null) {
                    for (let i = 0; i < this.award_templates_dynamic.length; i++) {
                        for (let k = 0; k < this.by_streamer_stats.length; k++) {
                            if (this.award_templates_dynamic[i].value <= this.by_streamer_stats[k].COUNTED) {
                                let template = JSON.parse(JSON.stringify(this.award_templates_dynamic));
                                template[i].bg = `/api/images/cards/streamer_images/${this.by_streamer_stats[k].SID}/avatar.png`;
                                template[i].desc=template[i].desc.replace("X"," "+this.by_streamer_stats[k].USER_NAME);
                                template[i].title=this.by_streamer_stats[k].USER_NAME+" "+template[i].title;
                                arr.push(template[i])
                            }
                        }
                    }
                }






                return arr;


            }




        },
        methods:{
            get_user_data(){
                let id = window.location.pathname.substring(11);

                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/user_stats?sid='+id;

                http.open("GET", url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;

                http.onreadystatechange = function () {

                    if (http.readyState === 4) {
                        if(http.status > 400){

                            console.log("error");

                        }
                        else {
                            let data=JSON.parse(http.response);
                            self.stats=data;

                        }

                    }
                };
                http.send();

            },
        get_card_stats:function(){
            let id = window.location.pathname.substring(11);

            let http = new XMLHttpRequest();
            http.withCredentials = true;
            let url = '/api/get_collector_stats?sid='+id;

            http.open("GET", url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            let self=this;

            http.onreadystatechange = function () {

                if (http.readyState === 4) {
                    if(http.status > 400){

                        console.log("error");

                    }
                    else {
                        let data=JSON.parse(http.response);
                        for(let i=0;i<data.all.length;i++){
                            if(data.all[i].RANK_VALUE===0){
                                self.num_rank0=data.all[i].COUNTED
                            }
                            else if(data.all[i].RANK_VALUE===1){
                                self.num_rank1=data.all[i].COUNTED
                            }
                            else if(data.all[i].RANK_VALUE===2){
                                self.num_rank2=data.all[i].COUNTED
                            }
                            else if(data.all[i].RANK_VALUE===3){
                                self.num_rank3=data.all[i].COUNTED
                            }
                        }
                        self.by_streamer_stats=data.by_streamer;

                    }

                }
            };
            http.send();
        }
        },
    }
</script>

<style scoped>


    .image-cropper {
        width: 100px;
        height: 100px;
        position: relative;
        overflow: hidden;
        border-radius: 50%;
    }



    .grow_me_badge { transition: all .2s ease-in-out;transform: scale(0.5); }
    .grow_me_badge:hover { transform: scale(0.8); }
</style>
